import deleteRequest from '../../../../../../deleteRequest';

/**
 * Bulk upload a campaign to multiple products.
 *
 * @param {{
 *  referenceIds: string[],
 *  productTypeIds: number[],
 *  siteId: number
 * }}
 * @param {string[]} referenceIds Product Ids
 * @param {number[]} productTypeIds Attribute Id
 * @param {number} siteId Site Id
*/
export default function deleteProductTypesProductId({
  referenceIds,
  productTypeIds,
  siteId,
}) {
  const endpoint = '/oc-product-bulkapi/v1/bulk-process/product-types/product-id';

  const body = {
    referenceIds,
    productTypeIds,
    siteId,
  };

  const successMessage = 'Started : Product Types : Prod ID (Delete)';
  const errorMessageHeader = `Failed to DELETE - IDs: ${productTypeIds} from Products: ${referenceIds}`;

  return new Promise((resolve, reject) => {
    deleteRequest(endpoint, body, errorMessageHeader, successMessage)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
}
